import { render } from "./FeeModal.vue?vue&type=template&id=7b5d88df"
import script from "./FeeModal.vue?vue&type=script&lang=js"
export * from "./FeeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__